import api from '../api/axios'

const portariaService = {
  // ── Entrada ──────────────────────────────────────────────────────────────────

  async listarEntradas(organizadorId, leilaoId) {
    const params = leilaoId ? { leilao_id: leilaoId } : {}
    const res = await api.get(`/organizadores/${organizadorId}/entrada-animais`, { params })
    return res.data
  },

  async criarEntrada(organizadorId, data) {
    const res = await api.post(`/organizadores/${organizadorId}/entrada-animais`, data)
    return res.data
  },

  async atualizarEntrada(organizadorId, entradaId, data) {
    const res = await api.put(`/organizadores/${organizadorId}/entrada-animais/${entradaId}`, data)
    return res.data
  },

  async excluirEntrada(organizadorId, entradaId) {
    await api.delete(`/organizadores/${organizadorId}/entrada-animais/${entradaId}`)
  },

  async saldoAnimais(organizadorId, leilaoId) {
    const res = await api.get(`/organizadores/${organizadorId}/entrada-animais-saldo/${leilaoId}`)
    return res.data
  },

  async relatorioEntrada(organizadorId, leilaoId) {
    const res = await api.get(`/organizadores/${organizadorId}/entrada-animais-relatorio/${leilaoId}`)
    return res.data
  },

  // ── Saída ─────────────────────────────────────────────────────────────────────

  async listarSaidas(organizadorId, leilaoId) {
    const params = leilaoId ? { leilao_id: leilaoId } : {}
    const res = await api.get(`/organizadores/${organizadorId}/saida-animais`, { params })
    return res.data
  },

  async criarSaida(organizadorId, data) {
    const res = await api.post(`/organizadores/${organizadorId}/saida-animais`, data)
    return res.data
  },

  async atualizarSaida(organizadorId, saidaId, data) {
    const res = await api.put(`/organizadores/${organizadorId}/saida-animais/${saidaId}`, data)
    return res.data
  },

  async excluirSaida(organizadorId, saidaId) {
    await api.delete(`/organizadores/${organizadorId}/saida-animais/${saidaId}`)
  },

  async relatorioSaida(organizadorId, leilaoId) {
    const res = await api.get(`/organizadores/${organizadorId}/saida-animais-relatorio/${leilaoId}`)
    return res.data
  },

  async pendentesSaida(organizadorId, leilaoId) {
    const res = await api.get(`/organizadores/${organizadorId}/saida-animais-pendentes/${leilaoId}`)
    return res.data
  },

  async rastreamentoVendedor(organizadorId, leilaoId) {
    const res = await api.get(`/organizadores/${organizadorId}/entrada-animais-rastreamento/${leilaoId}`)
    return res.data
  },
}

export default portariaService
